module.exports = __webpack_public_path__ + "img/bag-2.11e9c801.svg";